export const environment = {
  production: false,
  apiUrl: 'https://dev.cpolar.api-gateway.innovax.cl',
  autoRefreshIntervalMs: 180000
};
